import { useStore } from '@lifesci-ui/plugin/store'
import { useUserStore as userStore } from '@lifesci-ui/plugin/store/modules/user'
import useEnumItemStore from './modules/enumItem'
import useExamStore from './modules/exam'

const { createStore } = useStore()

const { createUserStore } = userStore()
export const useUserStore = createUserStore

export const useStorePlugin = () => ({
  enumItemStore: useEnumItemStore(),
  examStore: useExamStore(),
  ...createStore()
})

export default useStorePlugin
